import 'angular-block-ui';
import { defaultTo } from 'lodash/fp';
import api, { ApiService } from '../../../../common/api/api.service';
import appealsShow, { AppealsShowService } from '../show.service';
import users, { UsersService } from '../../../../common/users/users.service';

class CommittedController {
    appealId: string;
    blockUI: IBlockUIService;
    data: any[];
    meta: any;
    page: number;
    pageSize: number;
    watcher: () => void;
    constructor(
        private $log: ng.ILogService,
        private $rootScope: ng.IRootScopeService,
        private appealsShow: AppealsShowService,
        private api: ApiService,
        blockUI: IBlockUIService,
        users: UsersService,
    ) {
        this.blockUI = blockUI.instances.get('appealsCommitted');
        this.pageSize = defaultTo(25, users.getCurrentOptionValue('page_size_appeal'));
        this.page = 1;
    }
    $onInit() {
        this.watcher = this.$rootScope.$on('appeal:refresh', () => {
            this.load();
        });
    }
    $onDestroy() {
        this.watcher();
    }
    $onChanges() {
        this.appealsShow.deselectAll();
        if (this.appealId) {
            this.load();
        }
    }
    load(page: number = this.page): ng.IPromise<void> {
        this.blockUI.start();
        return this.api
            .get(`account_lists/${this.api.account_list_id}/pledges`, {
                include: 'contact',
                page: page,
                per_page: this.pageSize,
                fields: {
                    contacts: 'name,pledge_amount,pledge_currency,pledge_frequency',
                },
                filter: {
                    appeal_id: this.appealId,
                    status: 'not_received',
                },
                sort: 'contact.name',
            })
            .then((data: any) => {
                /* istanbul ignore next */
                this.$log.debug(`pledges not received page ${page}`, data);
                this.data = this.appealsShow.fixPledgeAmount(data);
                this.meta = data.meta;
                this.page = page;
                this.blockUI.reset();
            });
    }
    pageSizeChange(size) {
        this.pageSize = size;
        this.load(1);
    }
}

const Committed: ng.IComponentOptions = {
    template: require('./committed.html'),
    controller: CommittedController,
    bindings: {
        appealId: '<',
    },
};

export default angular
    .module('mpdx.tools.appeals.show.committed.component', ['blockUI', appealsShow, api, users])
    .component('appealCommitted', Committed).name;
